<div class="modal-header">
    <h4 class="modal-title fw-bold">Agregar plantilla</h4>
    <button type="button" class="btn-close" mat-dialog-close></button>
</div>
<mat-divider></mat-divider>
<mat-dialog-content>
    <div class="modal-body">
        <div>
            <span>Guarda los responsables de todas las áreas y reutilízalos en futuras diagramaciones.</span>
        </div>
        <mat-form-field appearance="outline" class="mt-2 w-100">
            <mat-label>Nombre de plantilla</mat-label>
            <input matInput [(ngModel)]="nombrePlantilla" maxlength="100"> 
        </mat-form-field>
        
    </div>
    <div class="modal-footer mt-2">
        <button mat-button mat-dialog-close>Cancelar</button>                
        <button mat-raised-button color="primary" (click)="guardarPlantillaVobos()">Guardar</button>
    </div>
</mat-dialog-content>

